import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ConsoleCloudAccountPoolSelectComponent } from './select/select.component';
import { CloudAccountPoolService } from '../service/pool.service';

@Component({
	selector: 'app-cloud-account-pool-dialog',
	templateUrl: 'pool.dialog.html',
	styleUrls: ['./pool.dialog.scss']
})
export class ConsoleCloudAccountPoolSetupDialog implements OnInit {

	cloudVendor: string;
	account: any;
	poolSetupType = 'selectPool';

	@ViewChild('poolSelect', {static: false}) poolSelect: ConsoleCloudAccountPoolSelectComponent;
	@ViewChild('poolCreate', {static: false}) poolCreate: ConsoleCloudAccountPoolSelectComponent;

	k8sPoolSelectionStateText = 'cloud-account.pool.select.content.select-k8s-pool';
	k8sPoolId: string;
	k8sPool: any;

	constructor(
		private dialog: MatDialog,
		private poolService: CloudAccountPoolService,
		private translateService: TranslateService,
		private dialogRef: MatDialogRef<ConsoleCloudAccountPoolSetupDialog>,
		@Inject(MAT_DIALOG_DATA) _data: any
	) {
		this.account = _data;
		this.cloudVendor = null;

		if (this.account.type === 'NHN') {
			this.cloudVendor = 'NHNCloud';
		} else if (this.account.type === 'NAVER') {
			this.cloudVendor = 'NaverCloudPlatform';
		} else if (this.account.type === 'KT') {
			this.cloudVendor = 'KTucloudBiz';
		}

		this.k8sPool = {};
		if (this.account && this.account.pools) {
			this.account.pools.forEach((pool: any) => {
				if (pool.usage === 'Container') {
					this.k8sPoolId = pool.poolId;
				}
			});
		}
		if (this.k8sPoolId) {
			this.poolService.get(this.k8sPoolId).subscribe(pool => {
				if (pool) {
					this.k8sPool = pool;
				}
				this.k8sPoolSelectionStateText = 'cloud-account.pool.select.content.k8s-pool-selected';
			});  
		}	  
	}

	ngOnInit() {
	}

	onTabChange() {
	}

	onPoolSetupChanged() {
	}

	doBrowseK8SPool() {
		this.poolService.doBrowsePool('Kubernetes').subscribe(selectedPool => {
			this.k8sPool = selectedPool.data[0].getData();
			this.k8sPoolSelectionStateText = 'cloud-account.pool.select.content.pool-selected';
		});
	}	

	onOk(): void {
		this.translateService.get([
			'common.invalid.alert',
			'cloud-account.pool.confirm.save',
			'cloud-account.pool.alert.saved',
			'cloud-account.pool.alert.save-failed'
		]).subscribe((messages: any) => {
			if (confirm(messages['cloud-account.pool.confirm.save'])) {
				if (this.poolSetupType === 'selectPool' && this.poolSelect) {
					const vmPool = this.poolSelect.validateForm(messages);
					this.poolService.save(this.account, vmPool, this.k8sPool).subscribe(() => {
						alert(messages['cloud-account.pool.alert.saved']);
						this.dialogRef.close({
							result: true
						});
					}, () => {
						alert(messages['cloud-account.pool.alert.save-failed']);
					});
				} else if (this.poolSetupType === 'createPool' && this.poolCreate) {
					const cloud = this.poolCreate.validateForm(messages);

					if (cloud) {
						this.poolService.cloudAutomation(cloud).subscribe((pool: any) => {
							this.poolService.save(this.account, pool, this.k8sPool).subscribe(() => {
								alert(messages['cloud-account.pool.alert.saved']);
								this.dialogRef.close({
									result: true
								});
							}, () => {
								alert(messages['cloud-account.pool.alert.save-failed']);
							});
						});
					}
				}
			}
		});
	}

	onClose(): void {
		this.dialogRef.close({
			result: false
		});
	}

}

